export enum FileFieldTableEnum {
  FileFieldName = 'fileFieldName',
  SystemFieldName = 'systemFieldName',
  Error = 'error',
  Option = 'option',
}
